import { useKeycloak } from "@react-keycloak/web";
import Http from "../engine/Http";
import { Identifiable } from "../model/Items";

export interface PriceList
extends Identifiable {
  name: string;
  startDate?: string;
  endDate?: string;
}

const usePriceListApi = () => {
  const { keycloak } = useKeycloak();
  const headers = [{ name: 'Authorization', value: `Bearer ${keycloak.token }` }];
  
  const fetchPriceLists = (): Promise<PriceList[]> => Http.get('api/price-lists', headers);
  
  const deletePriceList = (priceListId: number): Promise<PriceList> => Http.delete(`api/price-lists/${priceListId}`, headers);

  return {
    fetchPriceLists,
    deletePriceList
  };
};

export default usePriceListApi;